<template>
  <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" append-to-body width="70%">
    <table class="pic-analyse-table">
      <tr v-for="(tr, index) in tableFields" :key="`tableTr${index}`">
        <td v-for="(td, tdIndex) in tr.children" :key="`tr${index}td${tdIndex}${td.label}`">
          <template>
            <el-tooltip v-if="td.label" :visible-arrow="false" popper-class="alpha-color-ccc" :content="labelTooltip[td.label]" placement="top">
              <p class="analyse-td-label">{{ td.label }}：</p>
            </el-tooltip>
            <p
              v-if="Array.isArray(analyse[td.field])"
              :id="`tr${index}td${tdIndex}${td.label}`"
              class="analyse-td-content"
              @click="getChart(td.label, analyse[td.field], `tr${index}td${tdIndex}${td.label}`)"
            >
              {{ Array.isArray(analyse[td.field]) ? analyse[td.field][0] || '--' : analyse[td.field] || '--' }}
            </p>
            <p v-else-if="td.label" class="analyse-td-content">{{ analyse[td.field] || '--' }}</p>
          </template>
        </td>
      </tr>
    </table>
    <!-- popper -->
    <Popper
      :id="`radishAnalyse${company._id}`"
      :visible.sync="popperVisible"
      style="z-index: 31;"
      :target-id="popperTarget"
      container="projectTableWrapper"
    >
      <div class="radish-analyse-popper">
        <p class="popper-title">{{ popperDetail.title }}</p>
        <div class="chart-box">
          <div class="left-box">
            <p>
              <span class="mr10">总人数:{{ popperDetail.总人数 || 0 }}人</span
              ><span>有效数据:{{ popperDetail.有效数据 || 0 }}人</span>
            </p>
            <div id="popper-dom"></div>
          </div>
          <div class="right-box">
            <div class="detail-title">各{{ popperDetail.type }}比例</div>
            <div class="detail-content-box">
              <div class="detail-content radish-analyse-bottom-line" style="color:#919191;">
                <div class="detail-content-item">{{ popperDetail.type }}</div>
                <div class="detail-content-item">人数</div>
                <div class="detail-content-item">比例</div>
              </div>
              <div v-for="item in popperDetail.data" :key="item.label" class="detail-content">
                <div class="detail-content-item">{{ item.label }}</div>
                <div class="detail-content-item">{{ item.num }}</div>
                <div class="detail-content-item">{{ item.value }}{{item.label==='未知'?'':'%'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popper>
  </el-dialog>
</template>
<script>
import Popper from '../../../../../project/src/components/Popper'

const echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/bar')

const dateFormat = require('dateformat')

export default {
  components: { Popper },
  data() {
    return {
      dialogVisible: false,
      company: {},
      activeType: '',
      popperVisible: false,
      popperTarget: null,
      popperDetail: {
        title: '',
        type: '',
        data: [],
      },
      analyse: {},
      labelTooltip: {
        地域: '人员所在地域',
        性别: '人员性别统计',
        年龄: '人员平均年龄（5年一分类）',
        学历要求: '人员平均学历分布',
        学历标签: '人员学历标签分布',
        工作经验: '人员工作年限统计',
        业绩: '人员各业绩统计',
        稳定性: '公司人员稳定性统计',
        来源公司: '人员来源比例统计',
        来源行业: '人员来源行业比例统计',
        平台: '人员来源平台比例统计',
        专业能力: '人员各专业能力的比例',
        语言能力: '人员各语言能力的比例',
        领导能力: '人员各领导能力比例',
        '心态/性格': '人员各心态/性格标签的比例',
        个人风格: '人员个人风格比例',
        毕业院校: '人员毕业院校',
      },
      tableFields: [
        {
          children: [
            { label: '地域', field: '地域' },
            { label: '性别', field: '性别' },
            { label: '年龄', field: '年龄' },
            { label: '学历要求', field: '学历要求' },
            { label: '学历标签', field: '学历标签' },
            { label: '毕业院校', field: '毕业院校' },
          ],
        },
        {
          children: [
            { label: '业绩', field: '业绩' },
            { label: '稳定性', field: '稳定性' },
            { label: '来源公司', field: '来源公司' },
            { label: '来源行业', field: '来源行业' },
            { label: '平台', field: '平台' },
            { label: '工作经验', field: '工作经验' },
          ],
        },
        {
          children: [
            { label: '专业能力', field: '专业能力' },
            { label: '语言能力', field: '语言能力' },
            { label: '领导能力', field: '领导能力' },
            { label: '心态/性格', field: '心态/性格' },
            { label: '个人风格', field: '个人风格' },
            { label: '', field: '' },
          ],
        },
      ],
    }
  },
  watch: {
    flowGraphy:{
      handler(newValue, oldValue) {
        if(this.dialogVisible) this.loadSankey(newValue)
      },
      immediate:true,
    },
  },
  mounted(){
    const fields = []
    const { tableFields } = this
    tableFields.forEach(tr => {
      tr.children.forEach(td => {
        if (td.label) fields.push(td.field)
      })
    })
    this.analyseFields = fields
  },
  methods: {
    async open(company) {
      this.dialogVisible = true
      this.company = company
      this.loadDate()
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async loadDate() {
      const option = { cid: this.company._id }
      const res = await app.service('company').getCompanyStatistics(option)
      if (res.status === 'success') {
        const radishImage = (res.data && res.data[0]) || {}
        const obj = {}
        const echartObj = {}
        const countObj = {}
        this.analyseFields.forEach(v => {
          echartObj[v] = this.getDistribution(radishImage, v)
          countObj[v] = this.getCountNum(radishImage, v)
          obj[v] = this.radishImageTemplate(radishImage, v,countObj[v])
          echartObj[v].forEach(a=>{
            a.value = countObj[v].有效数据===0?a.value: (a.num / countObj[v].有效数据 * 100).toFixed(1)
          })
        })

        this.analyse = obj
        this.echartObj = echartObj
        this.countObj = countObj
      }
    },
    getDistribution(radishImage, item) {
      const val = radishImage[item]
      if (!val || !val['统计']) return []
      const arr = val['统计'].filter(v => v[0] !== '未知').slice(0, 10)
      if (arr.length > 0) {
        return arr
          .filter(a => (a[2] * 100).toFixed(1) !== '0.0')
          .map(a => ({ label: a[0], value: (a[2] * 100).toFixed(1), num: a[1] || 0 }))
      } else return []
    },
    getCountNum(radishImage, item) {
      const obj = {}
      const val = radishImage[item]
      if (!val || !val['统计']) return {}
      const arr = val['统计']
      const workArr = val['统计'].filter(v => v[0] !== '未知')
      if (arr.length > 0) {
        obj.总人数 = arr.reduce((prev, cur) => prev + (cur[1] || 0), 0)
        obj.有效数据 = workArr.reduce((prev, cur) => prev + (cur[1] || 0), 0)
        return obj
      } else return {}
    },
    radishImageTemplate(radishImage, item, count) {
      const val = radishImage[item]
      if (!val || !val['统计']) return ''
      const arr = val['统计'].filter(v => v[0] !== '未知').slice(0, 10)
      if (arr.length > 0) {
        return arr.filter(a => (a[2] * 100).toFixed(1) !== '0.0').map(a => `${a[0]}（${(a[1] / count.有效数据  * 100).toFixed(1)}%）`)
      } else return ''
    },
    getChart(type, fields, targetId) {
      this.popperVisible = false
      this.popperVisible = true
      this.popperTarget = targetId
      const { echartObj } = this
      const arr = echartObj[type]
      if (!arr || arr.length === 0) return this.$message.error('该类别没有数据')
      this.activeType = type

      const popperDetail = {
        title: `该公司员工${type}统计`,
        type: type,
        data: [],
      }

      arr.sort((a, b) => b.value - a.value)
      let option
      if (type === '性别') {
        option = {
          tooltip: {
            trigger: 'item',
            formatter: function(param) {
              const value = param.data
              return `${value.name}：${value.value}%`
            },
          },
          series: [
            {
              // name: '访问来源',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
              },
            },
          ],
        }
        const genderArr = arr.filter(v => ['男', '女'].includes(v.label))
        const other = {
          label: '未知',
          num: (this.countObj['性别'].总人数) - (this.countObj['性别'].有效数据 || 0),
        }
        genderArr.push(other)
        option.series[0].data = genderArr.map(v => ({ name: v.label, value: parseFloat(v.value) }))
        popperDetail.data = genderArr
        popperDetail.总人数 = this.countObj['性别'].总人数 || 0
        popperDetail.有效数据 = this.countObj['性别'].有效数据 || 0
        this.$nextTick(async _ => {
          const dom = this.$el.querySelector('#popper-dom')
          if(!dom) await this.delay(100)
          const myChart = echarts.init(dom)
          myChart.setOption(option, true)
        })
      } else {
        option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function(params) {
              const param = params[0]
              return `${param.name}：${param.value}%`
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            axisTick: {
              alignWithLabel: true,
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              name: '比例',
              type: 'bar',
              barWidth: '60%',
              // tooltip: {
              //   formatter: function(param) {
              //     const value = param.data
              //     return `${value.name}：${value.value}%`
              //   },
              // },
            },
          ],
        }
        option.xAxis.data = arr.map(v => v.label)
        option.series[0].data = arr.map(v => parseFloat(v.value))
        popperDetail.data = arr
        popperDetail.总人数 = this.countObj[type].总人数 || 0
        popperDetail.有效数据 = this.countObj[type].有效数据 || 0
        this.$nextTick(async _ => {
          const dom = this.$el.querySelector('#popper-dom')
          if(!dom) await this.delay(100)
          const myChart = echarts.init(dom)
          myChart.setOption(option, true)
        })
      }
      this.popperDetail = popperDetail
    },
  }
}
</script>
<style>
.alpha-color-ccc{
  border-color:#CCCCCC!important;
  box-shadow: 0 0 5px 0px #d0d0d0;
}
</style>
<style scoped>
table {
  margin: 0 auto;
  border-collapse: collapse;
  border-top: 1px solid #e1e0e0;
  border-left: 1px solid #e1e0e0;
}

td {
  height: 30px;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
  border-right: 1px solid #e1e0e0;
  border-bottom: 1px solid #e1e0e0;
  background-color: #fff;
}
thead td {
  background-color: #eff8ff;
}
.pic-analyse-table {
  width: 100%;
}
.pic-analyse-table td {
  width: 16%;
  padding: 5px 10px;
}
.pic-analyse-table .analyse-td-label {
  text-align: left;
  margin-bottom: 10px;
  color: #9f9f9f;
}
.radish-analyse-popper {
  padding: 10px 20px;
  border: 1px solid #eaeefb;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.popper-title {
  font-size: 18px;
  text-align: left;
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 8px;
}
.chart-box {
  display: flex;
  align-items: flex-end;
}
#popper-dom {
  width: 300px;
  height: 300px;
}
.right-box {
  width: 280px;
  padding-top: 10px;
}
.detail-title {
  background-color: #919191;
  padding: 6px;
  border-radius: 4px;
  text-align: center;
  color: #fff;
}
.detail-content {
  display: flex;
  padding: 2px;
}
.detail-content-item {
  width: 50%;
  text-align: center;
}
.radish-analyse-bottom-line {
  border-bottom: 1px solid #eee;
}
.analyse-td-content-item {
  border: 1px solid #eee;
  padding: 6px 10px;
}
.detail-content-box {
  border: 1px solid #eee;
}
.leader-item {
  border: 1px solid rgb(234, 234, 234);
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 10px;
  width: 100%;
}
</style>
